import { Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { useNumbers } from 'ui/components/utils/useNumbers'
import { PercentualLoyalty } from '../../../../../typings'
import { ReviewProps } from './constants'
import { messages } from './messages'

export function PercentualLoyaltyRecap(props: ReviewProps) {
  const { config } = props

  const { formatPercentual } = useNumbers()

  if (!config.benefit || !config.scope) return null

  const { scope } = config

  return (
    <FormattedMessage
      {...messages.percentualLoyalty}
      values={{
        b: (content) => <Text variant="action1">{content}</Text>,
        discount: formatPercentual((config.benefit as PercentualLoyalty).value),
        applyTo: scope.applyTo,
      }}
    />
  )
}
